import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { useModelCompareTranslation } from '../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { useMenu } from '../../../../contexts/MenuContext/context.mjs';
import { ButtonWrap, Button, CenterPlaceholderGridItem } from '../CompareTable.styles.mjs';
import { getStoreHref } from './getStoreHref.mjs';
"use strict";
const useButtonRenderer = () => {
  const {
    createSiteUrl,
    storeId
  } = useMenu();
  const {
    formatMessage
  } = useModelCompareTranslation();
  return useCallback(({
    product,
    index,
    getComingSoonButtonText,
    showBuyButton,
    onLinkClick
  }) => {
    const {
      id,
      isComingSoon = void 0,
      addToCartButton = void 0,
      startTrialLink = void 0,
      learnMoreLink = void 0
    } = product;
    const createButton = (label, href, variant = "primary") => {
      const BUTTONS_WITHOUT_POINTER_EVENTS = isComingSoon;
      return /* @__PURE__ */jsx(ButtonWrap, {
        children: /* @__PURE__ */jsx(Button, {
          $removePointerEvents: Boolean(BUTTONS_WITHOUT_POINTER_EVENTS),
          variant,
          anchor: !BUTTONS_WITHOUT_POINTER_EVENTS,
          span: Boolean(BUTTONS_WITHOUT_POINTER_EVENTS),
          href,
          onClick: e => href && onLinkClick?.(e, href),
          children: label
        })
      }, `${id}-${index}`);
    };
    if (addToCartButton) return addToCartButton;
    if (typeof isComingSoon === "boolean" && !!isComingSoon || Array.isArray(isComingSoon) && isComingSoon.includes(storeId)) {
      return createButton(getComingSoonButtonText(product), void 0, "comingSoon");
    }
    if (startTrialLink) {
      return createButton(formatMessage("Start Trial"), startTrialLink);
    }
    const learnMoreHref = learnMoreLink && createSiteUrl(learnMoreLink);
    if (learnMoreHref) {
      return createButton(formatMessage("Learn More"), learnMoreHref);
    }
    const storeHref = getStoreHref({
      product,
      createSiteUrl,
      storeId
    });
    if (!storeHref || !showBuyButton) {
      return /* @__PURE__ */jsx(CenterPlaceholderGridItem, {}, `${id}-${index}`);
    }
    return createButton(formatMessage("Buy Now"), storeHref);
  }, [createSiteUrl, storeId, formatMessage]);
};
export { useButtonRenderer };
//# sourceMappingURL=RenderButton.mjs.map
